// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main .holder>.line[data-v-5f9c2c6c]{margin-bottom:50px}.catalog .catalog-item[data-v-5f9c2c6c]{display:flex;flex-flow:column;width:100%;aspect-ratio:237/282}.catalog .catalog-item .catalog-img[data-v-5f9c2c6c]{overflow:hidden;height:100%;background-color:#f5f5f5;padding:1vw;display:flex;align-items:center;justify-content:center}.catalog .catalog-item .catalog-img img[data-v-5f9c2c6c]{max-height:100%;max-width:100%;width:auto}", ""]);
// Exports
module.exports = exports;
